export const AUTH_LOGOUT_COOLDOWN_UNTIL_KEY = 'aimanju:auth-logout-cooldown-until'
export const AUTH_LOGOUT_COOLDOWN_MS = 30_000
